import React from "react";
import { Button } from "./button";

export const CollectionDeleteModal = ({
  open,
  onClose,
  onDelete,
  collection = null,
  files = [],
  isLoading = false,
  deletionStepMessage = "",
}) => {
  if (!open || !collection) return null;

  const fileCount = files.length;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
        <h3 className="text-lg font-semibold mb-4 text-red-600">
          Delete Collection
        </h3>

        <div className="mb-4">
          <p className="text-gray-800 mb-2">
            Are you sure you want to delete the collection:{" "}
            <span className="font-semibold">"{collection.name}"</span>?
          </p>

          {fileCount > 0 && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 mt-3">
              <p className="text-yellow-800 text-sm font-medium mb-2">
                ⚠️ This will also delete {fileCount} associated file
                {fileCount !== 1 ? "s" : ""}:
              </p>
              <div className="max-h-32 overflow-y-auto">
                <ul className="text-sm text-yellow-700 space-y-1">
                  {files.slice(0, 5).map((file, index) => (
                    <li key={index} className="truncate">
                      • {file.name}
                    </li>
                  ))}
                  {files.length > 5 && (
                    <li className="text-yellow-600 italic">
                      ... and {files.length - 5} more files
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}

          <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mt-3">
            <p className="text-blue-800 text-sm">
              ℹ️ This will remove files from search index and database.
            </p>
          </div>

          <p className="text-red-600 text-sm mt-3 font-medium">
            This action cannot be undone.
          </p>
        </div>

        <div className="flex justify-end gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="bg-red-600 text-white hover:bg-red-700"
            onClick={onDelete}
            disabled={isLoading}
          >
            {isLoading
              ? deletionStepMessage || "Deleting collection..."
              : "Delete"}
          </Button>
        </div>
      </div>
    </div>
  );
};
